module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('card-news-item', {
    attrs: {
      "title": "Pagamento"
    }
  }, [(!_vm.calculo) ? _c('u-fake-loader', {
    staticClass: "m-t",
    attrs: {
      "width": "100%"
    }
  }) : _c('div', {
    staticClass: "row m-t"
  }, [(!_vm.preretiradas) ? _c('div', {
    staticClass: "col-xs-12"
  }, [_c('div', [_vm._v("Inicie primeiro a pré-retirada para realizar a análise do pagamento.")])]) : _c('div', {
    staticClass: "col-xs-12"
  }, [(_vm.somaPagamentos > 0) ? _c('div', [_vm._l((_vm.preretiradas), function(preretirada) {
    return (preretirada.status === 1) ? _c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-xs-6"
    }, [_vm._v(_vm._s(_vm.moment(preretirada.dataPagamento.date).format('L')))]), _vm._v(" "), _c('div', {
      staticClass: "col-xs-6 text-right font-bold"
    }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(preretirada.valor)))])]) : _vm._e()
  }), _vm._v(" "), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col-xs-12 m-t-n m-b-n"
  }, [_c('hr', {
    staticClass: "divider"
  })]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_vm._v("\n            Total pago: "), _c('span', {
    staticClass: "m-l-xs font-bold text-success"
  }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.somaPagamentos)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_vm._v("Custo "), _c('small', [_vm._v("(" + _vm._s(_vm.calculo.base.diarias) + " diárias)")]), _vm._v(": "), _c('span', {
    staticClass: "m-l-xs font-bold text-primary"
  }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.calculo.base.custoAtualizado)))])]), _vm._v(" "), _c('div', {
    staticClass: "col-xs-12 text-right"
  }, [_vm._v("\n            Saldo Devedor: "), _c('span', {
    staticClass: "m-l-xs font-bold",
    class: _vm.calculo.base.saldoDevedor > 0 ? 'text-danger' : ''
  }, [_vm._v("R$ " + _vm._s(_vm._f("moeda")(_vm.calculo.base.saldoDevedor)))])])])], 2) : _c('div', [_vm._v("\n        Nenhum pagamento reconhecido. Execute a consulta de pagamento por referência e defina a pré-retirada como paga.\n      ")])])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f3a2d2f2","hasScoped":true}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/app/website/grvs/components/grv-patio/CardNewsItemPagamento.vue
// module id = 1879
// module chunks = 17